import React from 'react'
import locationsMetadata from './locationsData';
import {Link, Redirect} from 'react-router-dom'
import Helmet from 'react-helmet'
import LocationsView from './LocationsView';
import {siteData} from './locationsData';
import RestaurantMap from './ReataurantMap';

export default function () {
  return(
     <div id="christmas-promotion" role="main" aria-labelledby="promotion-header">
  <Helmet>
    <title>{siteData.shortName} | Christmas Menu - Available Now!</title>
  </Helmet>
       
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Lobster&family=Outfit:wght@400;600;700&display=swap');
    
    @keyframes snowfall {
      0% {
        transform: translateY(-10px) rotate(0deg);
        opacity: 1;
      }
      100% {
        transform: translateY(100vh) rotate(360deg);
        opacity: 0.3;
      }
    }
    
    @keyframes sway {
      0%, 100% { margin-left: 0; }
      25% { margin-left: 15px; }
      75% { margin-left: -15px; }
    }
    
    #christmas-promotion {
      --diner-red: #c41e3a;
      --diner-green: #165b33;
      --diner-cream: #fdf6e3;
      --diner-gold: #d4a84b;
      --diner-dark: #2d1f1f;
      --diner-chrome: #e8e8e8;
      
      background: linear-gradient(170deg, #4a1c1c 0%, #2d1f1f 30%, #1a2e1a 70%, #0f1f0f 100%);
      color: var(--diner-cream);
      min-height: 100vh;
      font-family: 'Outfit', -apple-system, sans-serif;
      position: relative;
      overflow-x: hidden;
    }
    
    /* Snowflakes container */
    .snowflakes {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 1000;
      overflow: hidden;
    }
    
    .snowflake {
      position: absolute;
      top: -20px;
      color: #fff;
      font-size: 1em;
      text-shadow: 0 0 5px rgba(255,255,255,0.7);
      animation: snowfall linear infinite, sway ease-in-out infinite;
      opacity: 0.8;
    }
    
    .snowflake:nth-child(1) { left: 5%; animation-duration: 8s, 3s; font-size: 0.8em; animation-delay: 0s; }
    .snowflake:nth-child(2) { left: 15%; animation-duration: 12s, 4s; font-size: 1.2em; animation-delay: 1s; }
    .snowflake:nth-child(3) { left: 25%; animation-duration: 10s, 2.5s; font-size: 0.9em; animation-delay: 2s; }
    .snowflake:nth-child(4) { left: 35%; animation-duration: 14s, 3.5s; font-size: 1.1em; animation-delay: 0.5s; }
    .snowflake:nth-child(5) { left: 45%; animation-duration: 9s, 2s; font-size: 0.7em; animation-delay: 3s; }
    .snowflake:nth-child(6) { left: 55%; animation-duration: 11s, 4.5s; font-size: 1.3em; animation-delay: 1.5s; }
    .snowflake:nth-child(7) { left: 65%; animation-duration: 13s, 3s; font-size: 0.85em; animation-delay: 4s; }
    .snowflake:nth-child(8) { left: 75%; animation-duration: 10s, 2.8s; font-size: 1em; animation-delay: 2.5s; }
    .snowflake:nth-child(9) { left: 85%; animation-duration: 15s, 3.2s; font-size: 1.15em; animation-delay: 0.8s; }
    .snowflake:nth-child(10) { left: 95%; animation-duration: 8.5s, 4s; font-size: 0.75em; animation-delay: 3.5s; }
    .snowflake:nth-child(11) { left: 10%; animation-duration: 11.5s, 2.2s; font-size: 0.95em; animation-delay: 5s; }
    .snowflake:nth-child(12) { left: 30%; animation-duration: 9.5s, 3.8s; font-size: 1.05em; animation-delay: 4.5s; }
    .snowflake:nth-child(13) { left: 50%; animation-duration: 12.5s, 2.6s; font-size: 0.65em; animation-delay: 6s; }
    .snowflake:nth-child(14) { left: 70%; animation-duration: 10.5s, 3.4s; font-size: 1.25em; animation-delay: 5.5s; }
    .snowflake:nth-child(15) { left: 90%; animation-duration: 13.5s, 2.9s; font-size: 0.9em; animation-delay: 6.5s; }
    
    .promotion-container {
      max-width: 800px;
      margin: 0 auto;
      padding: 16px;
      text-align: center;
    }
    
    .promotion-header {
      background: linear-gradient(180deg, var(--diner-red) 0%, #8b1528 100%);
      color: var(--diner-cream);
      padding: 32px 20px;
      margin: 0 -16px 24px -16px;
      position: relative;
      border-bottom: 6px solid var(--diner-gold);
    }
    
    .promotion-header::before {
      content: '❄ ❄ ❄ ❄ ❄ ❄ ❄ ❄ ❄ ❄';
      position: absolute;
      top: 8px;
      left: 0;
      right: 0;
      font-size: 12px;
      letter-spacing: 8px;
      opacity: 0.6;
      overflow: hidden;
      white-space: nowrap;
    }
    
    .promotion-title {
      font-family: 'Lobster', cursive;
      font-size: 2.8em;
      font-weight: 400;
      margin-bottom: 8px;
      text-shadow: 3px 3px 0 rgba(0,0,0,0.3);
      letter-spacing: 1px;
    }
    
    .promotion-subtitle {
      font-size: 1.1em;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 3px;
      opacity: 0.95;
    }
    
    .order-notice {
      margin: 0 0 24px 0;
      background: var(--diner-green);
      border: 4px solid var(--diner-gold);
      border-radius: 0;
      padding: 24px 16px;
      position: relative;
    }
    
    .order-notice::before,
    .order-notice::after {
      content: '🎄';
      position: absolute;
      top: -12px;
      font-size: 24px;
    }
    
    .order-notice::before { left: 16px; }
    .order-notice::after { right: 16px; }
    
    .order-notice h3 {
      font-family: 'Lobster', cursive;
      color: var(--diner-cream);
      font-size: 1.6em;
      margin-bottom: 16px;
      font-weight: 400;
    }
    
    .order-notice p {
      color: var(--diner-cream);
      font-size: 1em;
      margin: 8px 0;
      line-height: 1.4;
    }
    
    .order-notice strong {
      color: var(--diner-gold);
    }
    
    .hours-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      margin: 16px 0;
      text-align: center;
    }
    
    .hours-box {
      background: rgba(0,0,0,0.25);
      padding: 12px 8px;
      border: 2px solid var(--diner-gold);
    }
    
    .hours-box .day {
      font-weight: 700;
      font-size: 0.85em;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 4px;
      color: var(--diner-gold);
    }
    
    .hours-box .time {
      font-size: 1.1em;
      font-weight: 600;
    }
    
    .cta-button,
    .cta-button:link,
    .cta-button:visited {
      background: var(--diner-red);
      color: #ffffff !important;
      padding: 14px 28px;
      font-size: 1.1em;
      font-weight: 700;
      border: 3px solid var(--diner-gold);
      cursor: pointer;
      text-decoration: none;
      display: inline-block;
      margin: 8px 6px;
      text-transform: uppercase;
      letter-spacing: 2px;
      transition: all 0.2s ease;
      font-family: 'Outfit', sans-serif;
    }
    
    .cta-button:hover,
    .cta-button:focus,
    .cta-button:active {
      background: var(--diner-gold);
      color: var(--diner-dark) !important;
      text-decoration: none;
      transform: scale(1.02);
    }
    
    .cta-button.phone,
    .cta-button.phone:link,
    .cta-button.phone:visited {
      background: transparent;
      border-color: var(--diner-cream);
      color: #ffffff !important;
    }
    
    .cta-button.phone:hover,
    .cta-button.phone:focus,
    .cta-button.phone:active {
      background: var(--diner-cream);
      color: var(--diner-green) !important;
    }
    
    .no-preorder-notice {
      margin-top: 12px;
      padding: 10px;
      background: rgba(0,0,0,0.3);
      font-size: 0.9em;
      border-left: 3px solid var(--diner-gold);
    }
    
    .menu-images-section {
      margin: 32px 0;
    }
    
    .menu-images-section h2 {
      font-family: 'Lobster', cursive;
      font-size: 2em;
      color: var(--diner-gold);
      margin-bottom: 16px;
      font-weight: 400;
    }
    
    .promotion-poster {
      width: 100%;
      max-width: 700px;
      height: auto;
      box-shadow: 
        0 0 0 4px var(--diner-gold),
        0 8px 32px rgba(0,0,0,0.5);
      margin: 16px auto;
      display: block;
    }
    
    .promotion-details {
      background: var(--diner-cream);
      color: var(--diner-dark);
      padding: 24px 20px;
      margin: 32px -16px;
      border-top: 6px solid var(--diner-red);
      border-bottom: 6px solid var(--diner-red);
      position: relative;
    }
    
    .promotion-details::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: 
        repeating-linear-gradient(
          90deg,
          transparent,
          transparent 20px,
          rgba(196,30,58,0.03) 20px,
          rgba(196,30,58,0.03) 40px
        );
      pointer-events: none;
    }
    
    .offer-text {
      font-family: 'Lobster', cursive;
      font-size: 2em;
      color: var(--diner-red);
      font-weight: 400;
      margin-bottom: 16px;
    }
    
    .terms {
      font-size: 1em;
      color: var(--diner-dark);
      line-height: 1.8;
      margin: 16px 0;
      position: relative;
    }
    
    .terms p {
      margin: 8px 0;
      padding: 6px 0;
      border-bottom: 1px dashed rgba(0,0,0,0.15);
    }
    
    .terms p:last-child {
      border-bottom: none;
    }
    
    .terms strong {
      color: var(--diner-green);
    }
    
    .locations-preview {
      margin-top: 40px;
      padding-bottom: 40px;
    }
    
    .locations-preview h2 {
      font-family: 'Lobster', cursive;
      color: var(--diner-gold);
      font-size: 1.8em;
      margin-bottom: 20px;
      font-weight: 400;
    }
    
    .locations-grid {
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;
    }
    
    .location-card {
      background: linear-gradient(180deg, #2a2a2a 0%, #1a1a1a 100%);
      border: 3px solid var(--diner-gold);
      padding: 20px;
      text-decoration: none;
      color: var(--diner-cream);
      transition: all 0.2s ease;
      width: 100%;
      max-width: 350px;
      box-sizing: border-box;
    }
    
    .location-card:hover {
      border-color: var(--diner-red);
      transform: translateY(-3px);
      box-shadow: 0 8px 24px rgba(196,30,58,0.3);
      color: var(--diner-cream);
      text-decoration: none;
      background: linear-gradient(180deg, #3a3a3a 0%, #2a2a2a 100%);
    }
    
    .location-card h3 {
      font-family: 'Lobster', cursive;
      color: var(--diner-gold);
      font-size: 1.4em;
      margin-bottom: 10px;
      font-weight: 400;
    }
    
    .location-card p {
      margin: 6px 0;
      font-size: 0.95em;
      line-height: 1.5;
    }
    
    .location-card a {
      color: var(--diner-gold);
      text-decoration: none;
      transition: color 0.2s;
    }
    
    .location-card a:hover {
      color: var(--diner-red);
    }
    
    /* Decorative snowflakes */
    .snowflake-decoration {
      text-align: center;
      font-size: 1.5em;
      letter-spacing: 12px;
      opacity: 0.4;
      margin: 24px 0;
    }
    
    /* Mobile optimizations */
    @media (max-width: 480px) {
      .promotion-title {
        font-size: 2.2em;
      }
      
      .promotion-subtitle {
        font-size: 0.9em;
        letter-spacing: 2px;
      }
      
      .cta-button {
        display: block;
        margin: 10px 0;
        padding: 16px 20px;
      }
      
      .hours-grid {
        grid-template-columns: 1fr;
        gap: 8px;
      }
      
      .promotion-details {
        padding: 20px 16px;
      }
      
      .offer-text {
        font-size: 1.6em;
      }
    }
    
    /* Larger screens */
    @media (min-width: 768px) {
      .promotion-container {
        padding: 24px;
      }
      
      .promotion-header {
        margin: 0 -24px 32px -24px;
        padding: 48px 32px;
        border-radius: 0 0 24px 24px;
      }
      
      .promotion-title {
        font-size: 3.5em;
      }
      
      .order-notice {
        padding: 32px;
        border-radius: 12px;
      }
      
      .promotion-details {
        margin: 40px -24px;
        padding: 40px;
        border-radius: 0;
      }
      
      .locations-grid {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
      }
    }
  `}</style>

  {/* Animated snowflakes */}
  <div className="snowflakes" aria-hidden="true">
    <div className="snowflake">❄</div>
    <div className="snowflake">❅</div>
    <div className="snowflake">❆</div>
    <div className="snowflake">❄</div>
    <div className="snowflake">❅</div>
    <div className="snowflake">❆</div>
    <div className="snowflake">❄</div>
    <div className="snowflake">❅</div>
    <div className="snowflake">❆</div>
    <div className="snowflake">❄</div>
    <div className="snowflake">❅</div>
    <div className="snowflake">❆</div>
    <div className="snowflake">❄</div>
    <div className="snowflake">❅</div>
    <div className="snowflake">❆</div>
  </div>

  <div className="promotion-container">
    <header className="promotion-header">
      <h1 id="promotion-header" className="promotion-title">Christmas Menu</h1>
      <p className="promotion-subtitle">Christmas Eve & Christmas Day</p>
    </header>

    <section className="order-notice">
      <h3>Join Us for Christmas!</h3>
      
      <div className="hours-grid">
        <div className="hours-box">
          <div className="day">Dec. 24</div>
          <div className="time">7 AM – 2 PM</div>
        </div>
        <div className="hours-box">
          <div className="day">Dec. 25</div>
          <div className="time">8 AM – 5 PM</div>
        </div>
      </div>
      
      <a href="/burbank/order" className="cta-button">Order Pickup / Delivery</a>
      <a href="tel:8188433433" className="cta-button phone">(818) 843-3433</a>
      
      <div className="no-preorder-notice">
        Order online on the day of — no preorders
      </div>
    </section>

    <div className="snowflake-decoration">❄ ❄ ❄</div>

    <section className="menu-images-section">
      <h2>Our Christmas Specials</h2>
      <img 
        src="https://afag.imgix.net/lancers-family-restaurant/christmas-menu.jpeg?w=1500&auto=format" 
        alt="Christmas Menu - Available on Christmas Eve and Christmas Day"
        className="promotion-poster"
      />
      <img 
        src="https://afag.imgix.net/lancers-family-restaurant/christmas-menu-1.jpeg?w=1500&auto=format" 
        alt="Christmas Menu - Available on Christmas Eve and Christmas Day"
        className="promotion-poster"
      />
    </section>

    <section className="promotion-details">
      <div className="offer-text">🎄 Holiday Dining at Lancer's 🎄</div>
      
      <div className="terms">
        <p><strong>Christmas Eve (Dec. 24):</strong> 7 AM to 2 PM</p>
        <p><strong>Christmas Day (Dec. 25):</strong> 8 AM to 5 PM</p>
        <p>Pickup & delivery available — order online when we're open</p>
        <p>No preorders — fresh made to order!</p>
      </div>
    </section>

    <div className="snowflake-decoration">❄ ❄ ❄</div>

    <section className="locations-preview" id="locations">
      <h2>Visit Us in Burbank</h2>
      <div className="locations-grid">
        {locationsMetadata.map(({id, label, address, phone}) => (
          <div 
            key={id} 
            className="location-card"
            aria-label={`Contact ${label} location for Christmas menu`}
          >
            <h3>{label}</h3>
            <p>{address[0]}<br/>{address[1]}</p>
            <p><strong>Call: <a href={`tel:${phone.replace(/[^0-9]/g, '')}`}>{phone}</a></strong></p>
          </div>
        ))}
      </div>
    </section>
  </div>

  <RestaurantMap />
</div>  
  )
}
